export const SYNTHETIC_CREATE = 'SYNTHETIC_CREATE';
export const SYNTHETIC_CLEAR = 'SYNTHETIC_CLEAR';
export const SYNTHETIC_TOGGLE = 'SYNTHETIC_TOGGLE';
export const SYNTHETIC_UPDATE_ACTIVE_INDEX = 'SYNTHETIC_UPDATE_ACTIVE_INDEX';
export const SYNTHETIC_UPDATE_ALL_PERSPECTIVES_OPACITY = 'SYNTHETIC_UPDATE_ALL_PERSPECTIVES_OPACITY';
export const SYNTHETIC_UPDATE_INDEX = 'SYNTHETIC_UPDATE_INDEX';
export const SYNTHETIC_UPDATE_ALL_PERSPECTIVES_INDEX = 'SYNTHETIC_UPDATE_ALL_PERSPECTIVES_INDEX';